module.exports = __webpack_public_path__ + "img/logo_ua_old3.6f962469.png";